import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { Gamepad2, BarChart3, Users, LogOut } from 'lucide-react';
import clsx from 'clsx';
import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../api/admin.api';
import { USER_ROLES } from '../utils/constants';

export const DashboardLayout: React.FC = () => {
  const handleLogout = () => {
    localStorage.removeItem('adminJwt');
    window.location.href = '/login';
  };

  const { data } = useQuery({
    queryKey: ['admin-profile'],
    queryFn: () => adminApi.profile(),
  });
  const isSuperAdmin = data?.data?.role === USER_ROLES.SUPER_ADMIN;

  const navigation = [
    { name: 'Games', href: '/games', icon: Gamepad2 },
    { name: 'Analytics', href: '/analytics', icon: BarChart3 },
    ...(isSuperAdmin ? [{ name: 'User Admin', href: '/users', icon: Users }] : []),
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="flex h-screen">
        {/* Sidebar */}
        <div className="w-64 bg-white shadow-lg">
          <div className="flex flex-col h-full">
            <div className="p-4 border-b">
              <h1 className="text-xl font-bold text-primary-600">Game Admin</h1>
            </div>
            
            <nav className="flex-1 p-4">
              <ul className="space-y-2">
                {navigation.map((item) => (
                  <li key={item.name}>
                    <NavLink
                      to={item.href}
                      className={({ isActive }) =>
                        clsx(
                          'flex items-center px-3 py-2 rounded-lg transition-colors',
                          isActive
                            ? 'bg-primary-50 text-primary-600'
                            : 'text-gray-700 hover:bg-gray-100'
                        )
                      }
                    >
                      <item.icon className="w-5 h-5 mr-3" />
                      {item.name}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </nav>
            <div className="p-4 border-t">
              <button
                onClick={handleLogout}
                className="flex items-center w-full px-3 py-2 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
              >
                <LogOut className="w-5 h-5 mr-3" />
                Logout
              </button>
            </div>
          </div>
        </div>

        {/* Main content */}
        <div className="flex-1 overflow-auto">
          <main className="p-8">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
};